// extracted by mini-css-extract-plugin
export default {"TestConfigTagBadge":"TestConfigTagBadge_TestConfigTagBadge__cvi3+"};